(function () {
  'use strict';
  scrolling.$inject = ['$compile'];
  angular.module('MktzapApp.Directives')
    .directive('scrolling', scrolling);
  function scrolling ($compile) {
    return {
	        link: function (scope, elem, attrs) {
	        	var sumWidth = 0;
	        	var elemCheck = elem.parent();
	        	var unwatch = scope.$watch('$last', function (params) {
	        		if (params) {
	        			scope.buildScrolling();
	        			unwatch();
	        		}
        });

        scope.scrolling = function (left) {
	        		var width = Math.floor(sumWidth / elemCheck.children().length);
		            if (left) {
		                elemCheck.animate({ scrollLeft: elemCheck.scrollLeft() - width }, 200);
		            } else {
		                elemCheck.animate({ scrollLeft: elemCheck.scrollLeft() + width }, 200);
		            }
		        };

        scope.buildScrolling = function () {
          var children = elemCheck.children();
          children.each(function (index) {
	        	        sumWidth += parseInt($(this).width());
	        	    });
	        	    if (sumWidth > elemCheck.width()) {
	        	        var arrowleft = angular.element('<a href="#" class="slide" ng-click="scrolling(true)"><i class="fa fa-arrow-left fa-2" aria-hidden="true"></i></a>');
            elemCheck.parent().prepend(arrowleft);
            $compile(arrowleft)(scope);
            var arrowRight = angular.element('<a href="#" class="slide" ng-click="scrolling(false)"><i class="fa fa-arrow-right fa-2" aria-hidden="true"></i></a>');
            elemCheck.parent().append(arrowRight);
            $compile(arrowRight)(scope);
		            }
        }
	        }
    }
  }
})();
